import { API } from '../../../../config';
import { errorHandler } from '../../auth/errorAction';

export const unmountListSkill = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_SKILL'})
}

export const unmountDetailSkill = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_SKILL'})
}

export const unmountMasterSkill = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_SKILL'})
}

export const listSkills = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_SKILL' })
  return API.GET('/skill/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_SKILL_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_SKILL_FAILED' }), 
    ))
  })
}

export const detailSkill = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_SKILL' })
  const params = {
    'id': id
  }
  API.GET('/skill/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_SKILL_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_SKILL_FAILED' }), 
      ))
    )
  })
}

export const masterSkills = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_SKILL' })
  return API.GET('/skill/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_SKILL_SUCCESS', 
      payload: { data: response.data }
    })
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_SKILL_FAILED' }), 
    ))
  })
}

export const createSkill = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/skill/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const updateSkill = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/skill/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableSkill = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/skill/enable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableSkill = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/skill/disable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}